export default __webpack_public_path__ + "static/media/GM.fe219354.ico";